import { isEdgeToExitNode } from '@/orchestrate/journeys/helpers';
import { PATCH_TYPE } from '@/orchestrate/journeys/graph.constants';

const { ADD, REMOVE } = PATCH_TYPE;

export function findEdgeFromNodeToExitNode ({ messageGraph, nodeFromId }) {
    const { edges } = messageGraph;

    return edges.find((edge) => edge.from === nodeFromId && isEdgeToExitNode(messageGraph, edge.id));
}

export function patchGraph ({ messageGraph, edgesPatchList = [], nodesPatchList = [] }) {
    // patchGraph is a function that patches the message graph with the given edges and nodes.
    // edgesPatch Type: { edge: EDGE, patch: PATCH_TYPE }
    // nodesPatch Type: { node: NODE, patch: PATCH_TYPE }
    let edges = [...messageGraph.edges];
    let nodes = [...messageGraph.nodes];

    edgesPatchList.forEach(({ edge, patch }) => {
        switch (patch) {
            case ADD:
                edges.push(edge);
                break;
            case REMOVE:
                edges = edges.filter((ed) => ed.id !== edge.id);
                break;
        }
    });

    nodesPatchList.forEach(({ node, patch }) => {
        switch (patch) {
            case ADD:
                nodes.push(node);
                break;
            case REMOVE:
                nodes = nodes.filter((nd) => nd.id !== node.id);
                break;
        }
    });

    return { ...messageGraph, edges, nodes };
}
